import { api, type CustomAxiosRequestConfig } from "@/shared/api/client";
import type { FileUsage, TenantFileUsage } from "../model/types";

// Os painéis mostram o erro no próprio estado; o toast global duplicaria a mensagem.
const silent = { skipErrorToast: true } as CustomAxiosRequestConfig;

export const fileUsageService = {
    /** Organização da sessão; exige `CAN_GET_FILE_USAGE`. */
    getCurrent: async (): Promise<FileUsage> => {
        const response = await api.get<FileUsage>("/files/usage", silent);
        return response.data;
    },

    /** Todas as organizações ativas; só com a claim `platformAdmin`. */
    getAllTenants: async (): Promise<TenantFileUsage[]> => {
        const response = await api.get<TenantFileUsage[]>("/files/usage/tenants", silent);
        return response.data;
    },
};
